import { Filter, IActiveFilters, IFilters, NumberRange, SelectList, SelectListMulti } from 'types';

const nullIndexNonExisting = -1;

export const filterItemCount = (filters: IFilters, filter: Filter): number => {
  if (filter.options.NUMBER_RANGE) {
    return filter.options.NUMBER_RANGE.map(range => filters.activeFilters[range.key]?.length ?? 0).reduce(
      (prev, curr) => prev + curr,
      0,
    );
  }
  if (filter.options.SELECT_MANY_MULTI) {
    const activeValues = filters.activeFilters[filter.key] ?? [];
    return filter.options.SELECT_MANY_MULTI.filter(option => option.value.some(v => activeValues.includes(v))).length;
  }
  return filters.activeFilters[filter.key]?.length ?? 0;
};

/**
 * Identifies if a given filter is active
 */
export const filterIsActive = (filter: Filter, activeFilters: IActiveFilters): boolean => {
  if (filter.options.NUMBER_RANGE) {
    return (
      filter.options.NUMBER_RANGE.findIndex(range =>
        activeFilters[range.key] ? activeFilters[range.key].length > 0 : false,
      ) > nullIndexNonExisting
    );
  }
  return activeFilters[filter.key] ? activeFilters[filter.key].length > 0 : false;
};

export const clearFilter = (filter: Filter, saveFilter: (key: string, values: string[]) => void): void => {
  if (filter.options.NUMBER_RANGE) {
    for (const range of filter.options.NUMBER_RANGE) {
      saveFilter(range.key, []);
    }
  } else {
    saveFilter(filter.key, []);
  }
};

export const getList = (filter: Filter): SelectList | SelectListMulti | NumberRange => {
  //console.log(`Get list input is ${filter}`);

  if (filter.options.SELECT_ONE || filter.options.SELECT_MANY || filter.options.SELECT_MANY_MULTI) {
    return getSelectList(filter);
  }
  return getNumberRange(filter);
};

export const getFilteredList = (filter: Filter, search: string): SelectList | SelectListMulti | NumberRange => {
  let selectedList: SelectList | SelectListMulti | NumberRange | undefined = undefined;
  if (filter.options.SELECT_ONE || filter.options.SELECT_MANY || filter.options.SELECT_MANY_MULTI) {
    selectedList = getSelectList(filter).filter(option => {
      return option.label?.toLocaleLowerCase().includes(search?.toLocaleLowerCase());
    }) as SelectList | SelectListMulti | NumberRange;
  } else if (filter.options.NUMBER_RANGE) {
    selectedList = getNumberRange(filter).filter(option => {
      return option.label?.toLocaleLowerCase().includes(search?.toLocaleLowerCase());
    });
  }
  // Fallback to an empty array if no matching filter type
  return selectedList ?? [];
};

const getSelectList = (filter: Filter): SelectList | SelectListMulti => {
  //console.log(`SELECT LIST INPUT IS ${JSON.stringify(filter)}`);

  if (filter.options?.SELECT_MANY) {
    return filter.options.SELECT_MANY;
  }
  if (filter.options?.SELECT_ONE) {
    return filter.options.SELECT_ONE;
  }
  if (filter.options?.SELECT_MANY_MULTI) {
    return filter.options.SELECT_MANY_MULTI;
  }
  return [];
};

const getNumberRange = (filter: Filter): NumberRange => {
  if (filter.options?.NUMBER_RANGE) {
    return filter.options.NUMBER_RANGE;
  }
  return [];
};
